<!-- STAR RATING -->
<span mat-icon-button class="star" *ngFor="let ratingId of ratingArr;index as i"  [id]="'star_'+i">
  <mat-icon>
      {{showIcon(i)}}
  </mat-icon>
</span>
